import { NavLink, NavLinkProps } from '@mantine/core';
import { useActiveRouteGroup } from 'shared/lib';
import { router } from 'shared/routing';
import cls from './nav-list.module.scss';

export type NavListProps = {
	label: string;
} & NavLinkProps;

export const NavList = ({ label, children, ...props }: NavListProps) => {
	const active = useActiveRouteGroup(children, router);

	return (
		<NavLink
			active={active}
			label={label}
			classNames={{
				root: cls.navListRoot,
				label: cls.navListLabel,
				section: cls.navListSection,
				body: cls.navListBody,
			}}
			{...props}
		>
			{children}
		</NavLink>
	);
};
